import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MdwListItem } from '@spaces-ui/meadow/components/list-item';
import { Channel, Mark, Logout } from '@spaces-ui/meadow/icons/svgs';

import { Sample } from '../../components';

@Component({
  selector: 'app-list-items',
  imports: [Sample, MdwListItem],
  templateUrl: './list-items.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './list-items.scss',
})
export class ListItems {
  public icons = { Channel, Logout, Mark };
  public selectedItem = -1;
  public accentedItem = 2;
  public isDisabled = true;
  public selectedTab = 'tab1';

  public alert(alertValue: string) {
    alert(alertValue);
  }
}
